import { useRef, useState } from 'react';

export function useNavbarLogic() {
  const [hoverStyle, setHoverStyle] = useState({
    opacity: 0,
    transform: 'scale(0.8)',
    left: '0%'
  });
  const navRef = useRef(null);
  const [textHover, setTextHover] = useState({});
  const [svgHover, setSvgHover] = useState(false);

  const handleMouseEnter = (index) => {
    const leftPosition = (index * 33.33) + '%';
    setHoverStyle({
      opacity: 1,
      transform: 'scale(1)',
      left: leftPosition,
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
    });
  };

  const handleTextMouseEnter = (index) => {
    setTextHover(prev => ({
      ...prev,
      [index]: true
    }));
  };

  const handleTextMouseLeave = (index) => {
    setTextHover(prev => ({
      ...prev,
      [index]: false
    }));
  };

  const handleMouseLeave = () => {
    setHoverStyle(prev => ({
      ...prev,
      opacity: 0,
      transform: 'scale(0.8)',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
    }));
  };

  const handleSvgMouseEnter = () => {
    setSvgHover(true);
  };

  const handleSvgMouseLeave = () => {
    setSvgHover(false);
  };

  return {
    hoverStyle,
    navRef,
    textHover,
    svgHover,
    handleMouseEnter,
    handleTextMouseEnter,
    handleTextMouseLeave,
    handleMouseLeave,
    handleSvgMouseEnter,
    handleSvgMouseLeave
  };
}

export function useDoubleTextLogic(text) {
  const letters = text.split('');
  return { letters };
}